import React from 'react';
import { authPostRequest } from '../services/api-service';
import { getAllUsersByRoleUrl } from '../seed/url';
import {
  SMAIADMIN,
  SMAICASHIER,
  SMAIDISPATCHMANAGER,
  SMAIINVENTORYMANAGER,
  SMAISECRETARY,
  SMAISUPERVISOR,
  VENDOR,
} from '../utils/constant';

const STAFF_ROLES = [
  SMAISECRETARY,
  SMAISUPERVISOR,
  SMAICASHIER,
  SMAIADMIN,
  SMAIINVENTORYMANAGER,
  SMAIDISPATCHMANAGER,
  VENDOR,
];

export const getUserDisplayName = (user) => {
  const name = `${user.firstName || ''} ${user.secondName || ''}`.trim();
  return name || user.userName || `User #${user.id}`;
};

const fetchUsersByRole = (role) =>
  new Promise((resolve) => {
    authPostRequest(
      getAllUsersByRoleUrl,
      {
        role,
        sort: 'id desc',
        limit: 100,
        page: 1,
      },
      (data) => resolve(data?.results || []),
      () => resolve([]),
    );
  });

export function useStaffUsers() {
  const [users, setUsers] = React.useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = React.useState(true);

  React.useEffect(() => {
    let isMounted = true;

    const loadUsers = async () => {
      setIsLoadingUsers(true);
      const results = await Promise.all(STAFF_ROLES.map(fetchUsersByRole));
      if (!isMounted) {
        return;
      }

      const uniqueUsers = Array.from(
        new Map(results.flat().map((user) => [user.id, user])).values(),
      ).sort((a, b) => getUserDisplayName(a).localeCompare(getUserDisplayName(b)));

      setUsers(
        uniqueUsers.map((user) => ({
          ...user,
          userName: getUserDisplayName(user),
        })),
      );
      setIsLoadingUsers(false);
    };

    loadUsers();

    return () => {
      isMounted = false;
    };
  }, []);

  return { users, isLoadingUsers };
}
